/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Cannot_DisableInputs */

const en_disabled_websites_cannot_disable = /** @type {(inputs: Disabled_Websites_Cannot_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot Disable (Already Enabled with Limited Compatibility)`)
};

const es_disabled_websites_cannot_disable = /** @type {(inputs: Disabled_Websites_Cannot_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede deshabilitar (ya habilitado con compatibilidad limitada)`)
};

/**
* | output |
* | --- |
* | "Cannot Disable (Already Enabled with Limited Compatibility)" |
*
* @param {Disabled_Websites_Cannot_DisableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_cannot_disable = /** @type {((inputs?: Disabled_Websites_Cannot_DisableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Cannot_DisableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_cannot_disable(inputs)
	return en_disabled_websites_cannot_disable(inputs)
});